import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxmYWNpYWwlMjBtYXNzYWdlJTIwc3BhJTIwd29tYW58ZW58MHx8fHwxNzc3Njg5OTYzfDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      {/* Image side */}
      <div className="absolute inset-0 md:inset-y-0 md:left-1/2 md:right-0">
        <div className="relative h-full w-full overflow-hidden">
          <img
            src={HERO_IMG}
            alt="Serene mobile beauty treatment in Auckland"
            className="h-full w-full object-cover slow-zoom"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#FAEDE6] via-[#FAEDE6]/30 to-transparent md:from-[#FAEDE6]/95 md:via-[#FAEDE6]/30 md:to-transparent" />
          <div className="absolute inset-0 bg-black/10 md:bg-transparent" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 pt-40 pb-24 md:py-0 md:min-h-[100svh] flex items-center">
        <div className="max-w-2xl fade-up">
          <div className="flex items-center gap-4 mb-8">
            <span className="h-px w-10 bg-[#B78782]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#B78782]">
              Auckland · Mobile Beauty Specialist
            </span>
          </div>

          <h1 className="font-serif-display text-[#4A3737] text-[52px] sm:text-[64px] md:text-[78px] lg:text-[96px] leading-[0.95] font-light tracking-tight">
            Beauty
            <br />
            that comes
            <br />
            <span className="font-script text-[#B78782] text-[58px] sm:text-[72px] md:text-[88px] lg:text-[110px] tracking-normal">
              to&nbsp;you.
            </span>
          </h1>

          <p className="mt-10 max-w-md text-[15px] md:text-base leading-relaxed text-[#4A3737]/80 font-light">
            Luxury facials, LED therapy, mesotherapy, microneedling and chemical
            peels — delivered with quiet expertise in the comfort of your own
            home, anywhere across Auckland.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a
              href="#services"
              data-testid="hero-explore-btn"
              className="inline-flex items-center text-[12px] tracking-[0.28em] uppercase bg-[#B78782] text-[#FAEDE6] px-7 py-4 hover:bg-[#C5A8A4] transition-colors duration-300"
            >
              Explore Services
            </a>
            <a
              href="#contact"
              data-testid="hero-enquire-btn"
              className="inline-flex items-center text-[12px] tracking-[0.28em] uppercase border border-[#B78782] text-[#4A3737] px-7 py-4 hover:bg-[#B78782]/10 transition-colors duration-300"
            >
              Enquire with Amber
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <a
        href="#about"
        aria-label="Scroll down"
        className="hidden md:flex absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex-col items-center gap-2 text-[#4A3737]/70 hover:text-[#B78782] transition-colors"
      >
        <span className="text-[10px] tracking-[0.4em] uppercase">Scroll</span>
        <ArrowDown size={16} className="animate-bounce" />
      </a>
    </section>
  );
}
